import {
  ButtonStyle,
  Card,
  FullWidthLayout,
  LinkButton,
} from '@versita/frontend/campus-ui-web';

import { useUserWidget } from '../../hooks/useUserWidget';

import { StudentTimetableList } from '../../organisms/StudentTimetableList';
import { Actions } from '@versita/shared/models';
import { useHasPermission } from '@versita/frontend/auth-web';

/**
An admin dashboard for timetable admins/managers
*/
export const TimetableAdminDashboard = () => {
  const userWidget = useUserWidget();
  const canEdit = useHasPermission(Actions.Timetable.Write.All);

  return (
    <FullWidthLayout
      userWidget={userWidget}
      heading={{
        title: 'Admin Dashboard',
        subtitle: 'Student Timetables',
      }}
    >
      <LinkButton $buttonStyle={ButtonStyle.Secondary} to="/courses">
        Search for a course timetable
      </LinkButton>
      <br />
      {canEdit && (
        <LinkButton $buttonStyle={ButtonStyle.Secondary} to="/admin/timetable">
          {`Manage Timetables`}
        </LinkButton>
      )}
      <h2>Student Timetables</h2>
      <Card $fullWidth>
        <StudentTimetableList />
      </Card>
    </FullWidthLayout>
  );
};

export default TimetableAdminDashboard;
